/**
 * ClickUp-style accent colour schemes. The full 50–900 brand scale + sidebar background
 * for each accent lives in index.css under `[data-accent="<id>"]`; here we only keep the
 * id/label + a representative swatch colour used by the theme picker's colour dots.
 */

export const ACCENTS = [
  { id: 'black', label: 'Black', swatch: '#404040' },
  { id: 'purple', label: 'Purple', swatch: '#7c3aed' },
  { id: 'blue', label: 'Blue', swatch: '#2563eb' },
  { id: 'pink', label: 'Pink', swatch: '#db2777' },
  { id: 'violet', label: 'Violet', swatch: '#a855f7' },
  { id: 'indigo', label: 'Indigo', swatch: '#4f46e5' },
  { id: 'orange', label: 'Orange', swatch: '#ea580c' },
  { id: 'teal', label: 'Teal', swatch: '#0d9488' },
  { id: 'bronze', label: 'Bronze', swatch: '#8a5a40' },
  { id: 'mint', label: 'Mint', swatch: '#059669' },
] as const;

export type Accent = (typeof ACCENTS)[number]['id'];

export const ACCENT_IDS = ACCENTS.map((a) => a.id) as readonly Accent[];

export const DEFAULT_ACCENT: Accent = 'indigo';

/** Narrows an arbitrary string to a known accent id, falling back to the default. */
export function normalizeAccent(value: string | null | undefined): Accent {
  return (ACCENT_IDS as readonly string[]).includes(value ?? '')
    ? (value as Accent)
    : DEFAULT_ACCENT;
}
